import PropTypes from 'prop-types'

const FuneralHomeHeading = ({clientName, funeralHomeName, isQuarterback}) => (
  <span
    className='funeral-home-heading row-wrapper-sb'
    data-testid='funeral-home-heading'>
    <h1>{clientName}</h1>
    {
      isQuarterback &&
      <span>
        <strong>Funeral Home:</strong> {funeralHomeName}
      </span>
    }
  </span>
)

FuneralHomeHeading.defaultProps = {
  funeralHomeName: '',
  isQuarterback: false
}

FuneralHomeHeading.propTypes = {
  clientName: PropTypes.string.isRequired,
  funeralHomeName: PropTypes.string,
  isQuarterback: PropTypes.bool
}

export default FuneralHomeHeading
